import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssigTripsService } from '../../assigntrips-service/assigntrips-service';
import * as moment from "moment-timezone";

@Injectable({
  providedIn: 'root'
})
export class DriverLoadV4Service {

  constructor(
    private http: HttpClient,
    private assignTripService: AssigTripsService
  ) { }

  async setupTripsByPickup(params) {
    const {
      todayDate,
      user,
      selectedDriverId,
      drivers,
      violations,
      preSpaceTypes,
      selectedTimeLines,
      driverTrips,
      selectedTripsDriver,
      isGoogleMiles,
      singleOverrideShift
    } = params;

    console.log('params', params);

    if (!selectedDriverId) return;

    const timeZone = user.timeZone;
    const currentDay = moment.tz(todayDate, timeZone).day();
    const points = this.getSortedPoints(driverTrips);
    console.log('Points', points);
    const tripsPickupPoints = [];

    let selectedDriver = drivers.find(d => d._id === selectedDriverId);
    let driverShift;
    if (singleOverrideShift) {
      driverShift = singleOverrideShift;
    } else if (selectedDriver.shifts) {
      driverShift = selectedDriver.shifts.find(item => item.day === currentDay && item.isEnabled);
    }

    const shiftParams = {
      timeZone,
      todayDate,
      selectedDriver,
      driverShift,
      selectedTimeLines,
      tripsPickupPoints,
      isGoogleMiles
    };
    this.insertDriverShift({ isShiftStart: true, ...shiftParams }); // calling order matters

    for (let point of points) {
      let _eta = moment(point.time).tz(timeZone);
      let distance = 0;
      let travel = moment().tz(timeZone).set({ minute: 0, hour: 0, second: 0 }).toISOString();

      let previousPoint = this.getPreviousTrip(tripsPickupPoints);
      // not break case
      if (!point.isBreakTrip) {
        // if point belongs to trip
        if (previousPoint && previousPoint.priorityClient) {
          if (!point.isDone) {
            let distanceRes = { duration: 0, distance: 0 };

            distanceRes = await this.assignTripService.getDistance(
              previousPoint.lat,
              previousPoint.lng,
              point.lat,
              point.lng,
              isGoogleMiles
            );

            // check last trip is running or done
            if (previousPoint.isRunning || previousPoint.isDone) {
              _eta = moment(previousPoint.time).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes');

              if (previousPoint.isRunning) {
                // if driver location comming
                if (selectedTripsDriver && selectedTripsDriver.latitude !== null && selectedTripsDriver.longitude !== null) {
                  distanceRes = await this.assignTripService.getDistance(
                    selectedTripsDriver.latitude,
                    selectedTripsDriver.longitude,
                    point.lat,
                    point.lng,
                    isGoogleMiles
                  );
                  _eta = moment(previousPoint.time).add(distanceRes.duration.toFixed(0), 'minutes').tz(timeZone);
                } else if (previousPoint.event) {
                  // last point most recent event
                  distanceRes = await this.assignTripService.getDistance(
                    previousPoint.event[1],
                    previousPoint.event[0],
                    point.lat,
                    point.lng,
                    isGoogleMiles
                  );
                  _eta = moment(previousPoint.time).add(distanceRes.duration.toFixed(0), 'minutes').tz(timeZone);
                }

              } else {
                // if done previous then overide with recent action
                previousPoint.eta = moment(previousPoint.time).clone().toISOString();

                if (selectedTripsDriver && selectedTripsDriver.latitude !== null && selectedTripsDriver.longitude !== null) {
                  distanceRes = await this.assignTripService.getDistance(
                    selectedTripsDriver.latitude,
                    selectedTripsDriver.longitude,
                    point.lat,
                    point.lng,
                    isGoogleMiles
                  );
                  _eta = moment(previousPoint.time).add(distanceRes.duration.toFixed(0), 'minutes').tz(timeZone);
                }

              }



            } else {
              _eta = moment(previousPoint.eta).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes');
            }

            const checkTimeAfter = moment().tz(timeZone).isAfter(_eta);
            if (checkTimeAfter) {
              _eta = moment().tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes');
            }
          }
        } else {
          // if point belongs to Driver
          if (selectedTripsDriver && selectedTripsDriver.latitude !== null && selectedTripsDriver.longitude !== null) {
            const distanceRes = await this.assignTripService.getDistance(
              selectedTripsDriver.latitude,
              selectedTripsDriver.longitude,
              point.lat,
              point.lng,
              isGoogleMiles
            );

            if (previousPoint && !point.isDone) {
              _eta = moment(previousPoint.time).add(distanceRes.duration.toFixed(0), 'minutes').tz(timeZone);
            }

          }
        }

        // Calculate distance and travel time from previous point
        const result = await this.getTravelTimeAndDistance(point, previousPoint, timeZone, isGoogleMiles);
        distance = result.distance;
        travel = moment(previousPoint.travel).tz(timeZone).add(result.duration.toFixed(0), 'minutes').toISOString();

        // Early Arrival then update eta
        if (point && point.priorityClient && !point.isBreakTrip && !point.isDone) {
          let checkTimeWith = point.isPickup ? point.scheduleTime : point.appointmentTime;
          const isStartEarly = moment(checkTimeWith).tz(timeZone).isAfter(_eta);
          if (isStartEarly) {
            let durationOfTripTime = moment.duration(_eta.diff(moment(checkTimeWith).tz(timeZone)));
            if (violations && violations.single && violations.single.pickupEarly !== 0 && Math.abs(durationOfTripTime.asMinutes()) > violations.single.pickupEarly) {
              _eta = moment(checkTimeWith).tz(timeZone).subtract(violations.single.pickupEarly, 'minutes');
            }
          }
        }

      } else {
        // break case
        if (previousPoint) {
          _eta = moment(previousPoint.eta).tz(timeZone);
          distance = previousPoint.distance;
          travel = moment(previousPoint.travel).tz(timeZone).toISOString();
        }
      }

      tripsPickupPoints.push({
        ...point,
        eta: _eta.toISOString(),
        distance: distance,
        travel: travel,
      });

    }

    this.insertDriverShift({ isShiftStart: false, ...shiftParams }); // calling order matters

    console.log('tripsPickupPoints', tripsPickupPoints);

    const orderMap = {};
    tripsPickupPoints.forEach((point, idx) => {
      if (point._id && !point.isBreakTrip) {
        if (!orderMap[point._id]) orderMap[point._id] = {};
        if (point.isPickup) orderMap[point._id].pickupOrder = idx;
        if (point.isDropOff) orderMap[point._id].dropOffOrder = idx;
      }
    });

    tripsPickupPoints.forEach((point, idx) => {
      if (point._id && orderMap[point._id]) {
        point.pickupOrder = orderMap[point._id].pickupOrder;
        point.dropOffOrder = orderMap[point._id].dropOffOrder;
      } else {
        // For shift points or others without trip _id
        point.pickupOrder = idx;
        point.dropOffOrder = idx;
      }
    });

    return tripsPickupPoints;
  }

  async insertDriverShift(params) {
    const {
      isShiftStart,
      timeZone,
      todayDate,
      selectedDriver,
      driverShift,
      selectedTimeLines,
      tripsPickupPoints,
      isGoogleMiles
    } = params;

    if (selectedDriver) {
      if (isShiftStart) {
        // checking driver and shift time
        selectedDriver.isPickup = true;
        selectedDriver.isDropOff = true;
        selectedDriver.jobOriginAddress = selectedDriver.startingPointAddress.address;
        selectedDriver.jobOriginLatitude = selectedDriver.startingPointAddress.latitude;
        selectedDriver.jobOriginLongitude = selectedDriver.startingPointAddress.longitude;

        selectedDriver.jobDestinationAddress = selectedDriver.startingPointAddress.address;
        selectedDriver.jobDestinationLatitude = selectedDriver.startingPointAddress.latitude;
        selectedDriver.jobDestinationLongitude = selectedDriver.startingPointAddress.longitude;

        if (driverShift) {

          tripsPickupPoints.push({
            ...selectedDriver,
            lat: selectedDriver.startingPointAddress.latitude,
            lng: selectedDriver.startingPointAddress.longitude,
            appointmentTime: moment.tz(todayDate, timeZone).set({ minute: driverShift.checkin.split(':')[1], hour: driverShift.checkin.split(':')[0], second: 0 }).toISOString(),
            scheduleTime: moment.tz(todayDate, timeZone).set({ minute: driverShift.checkin.split(':')[1], hour: driverShift.checkin.split(':')[0], second: 0 }).toISOString(),
            time: moment.tz(todayDate, timeZone).set({ minute: driverShift.checkin.split(':')[1], hour: driverShift.checkin.split(':')[0], second: 0 }).toISOString(),
            eta: moment.tz(todayDate, timeZone).set({ minute: driverShift.checkin.split(':')[1], hour: driverShift.checkin.split(':')[0], second: 0 }).toISOString(),
            distance: 0,
            travel: moment.tz(todayDate, timeZone).startOf('day').toISOString()
          });


          if (selectedTimeLines && selectedTimeLines.checkin) {
            const previousTrip = tripsPickupPoints[tripsPickupPoints.length - 1];
            previousTrip.eta = moment(selectedTimeLines.checkin).tz(timeZone).toISOString();
            previousTrip.arrive = moment(selectedTimeLines.checkin).tz(timeZone).toISOString();
            previousTrip.perform = moment(selectedTimeLines.checkin).tz(timeZone).toISOString();
            previousTrip.time = moment(selectedTimeLines.checkin).tz(timeZone).toISOString();
          }

        } else {
          //  start of day if shift not exist
          tripsPickupPoints.push({
            ...selectedDriver,
            lat: selectedDriver.startingPointAddress.latitude,
            lng: selectedDriver.startingPointAddress.longitude,
            appointmentTime: moment.tz(todayDate, timeZone).startOf('day').toISOString(),
            scheduleTime: moment.tz(todayDate, timeZone).startOf('day').toISOString(),
            time: moment.tz(todayDate, timeZone).startOf('day').toISOString(),
            eta: moment.tz(todayDate, timeZone).startOf('day').toISOString(),
            distance: 0,
            travel: moment.tz(todayDate, timeZone).startOf('day').toISOString()
          });
        }
        // chnage eta on base of current time in case of time get passed
        let firstDriverTrip = tripsPickupPoints[tripsPickupPoints.length - 1];

        const checkTimeAfter = moment().tz(timeZone).isAfter(moment(firstDriverTrip.eta).tz(timeZone));
        if (checkTimeAfter) {
          firstDriverTrip.eta = moment().tz(timeZone).toISOString();
          firstDriverTrip.time = moment().tz(timeZone).toISOString();

        }
      } else {
        // In shift end case
        selectedDriver.isPickup = true;
        selectedDriver.isDropOff = true;

        let previousTrip = this.getPreviousTrip(tripsPickupPoints);

        let distanceRes;
        distanceRes = await this.assignTripService.getDistance(previousTrip.lat, previousTrip.lng, selectedDriver.startingPointAddress.latitude, selectedDriver.startingPointAddress.longitude, isGoogleMiles);

        if (driverShift) {
          const eta = moment(previousTrip.eta).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString();
          tripsPickupPoints.push({
            ...selectedDriver,
            lat: selectedDriver.startingPointAddress.latitude,
            lng: selectedDriver.startingPointAddress.longitude,
            appointmentTime: moment.tz(todayDate, timeZone).set({ minute: driverShift.checkout.split(':')[1], hour: driverShift.checkout.split(':')[0], second: 0 }),
            scheduleTime: moment.tz(todayDate, timeZone).set({ minute: driverShift.checkout.split(':')[1], hour: driverShift.checkout.split(':')[0], second: 0 }),
            time: eta,
            eta: eta,
            distance: distanceRes.distance,
            travel: moment(previousTrip.travel).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString(),
          });


          // set Check out time in shift case
          if (selectedTimeLines && selectedTimeLines.checkout) {
            const previousTrip = tripsPickupPoints[tripsPickupPoints.length - 1];
            previousTrip.arrive = moment(selectedTimeLines.checkout).tz(timeZone).toISOString();
            previousTrip.perform = moment(selectedTimeLines.checkout).tz(timeZone).toISOString();
          }

        } else {

          const time = moment(previousTrip.eta).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString();
          let eta = moment(previousTrip.eta).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString();
          // removed eta from
          tripsPickupPoints.push({
            ...selectedDriver,
            lat: selectedDriver.startingPointAddress.latitude,
            lng: selectedDriver.startingPointAddress.longitude,
            appointmentTime: time,
            scheduleTime: time,
            time: eta,
            distance: distanceRes.distance,
            eta,
            travel: moment(previousTrip.travel).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString(),
          });
        }
      }
    }
  }

  getSortedPoints(driverTrips) {
    let points = [];

    if (driverTrips && driverTrips.length) {

      for (let trip of driverTrips) {

        const pick = {
          isPickup: true,
          isDropOff: false,
          time: trip.scheduleTime,
          lat: trip.jobOriginLatitude,
          lng: trip.jobOriginLongitude,
          isDone: false,
          isRunning: false,
          event: null
        }
        const pickupEvent = this.getPickupEvent(trip);
        if (pickupEvent.event) {
          pick.time = pickupEvent.event.time;
          pick.lat = pickupEvent.event.coords[1];
          pick.lng = pickupEvent.event.coords[0];
          pick.isDone = pickupEvent.isDone;
          pick.isRunning = pickupEvent.isRunning;
          pick.event = pickupEvent.event;

        }

        const drop = {
          isDropOff: true,
          isPickup: false,
          time: trip.appointmentTime,
          lat: trip.jobDestinationLatitude,
          lng: trip.jobDestinationLongitude,
          isDone: false,
          isRunning: false,
          event: null
        }

        const dropOffEvent = this.getDropOffEvent(trip);
        if (dropOffEvent.event) {
          // incase if on arrive missed
          if (!pick.isDone) pick.isDone = true;

          drop.time = dropOffEvent.event.time;
          drop.lat = dropOffEvent.event.coords[1];
          drop.lng = dropOffEvent.event.coords[0];
          drop.isDone = dropOffEvent.isDone;
          drop.isRunning = dropOffEvent.isRunning;
          drop.event = dropOffEvent.event;
        }

        points.push({ ...trip, ...pick });
        points.push({ ...trip, ...drop });
      }

      // points.sort((a, b) => {
      //   return moment(a.time).diff(moment(b.time));
      // });


      // points.sort((a, b) => {
      //   if (a.isDone !== b.isDone) {
      //     return b.isDone - a.isDone; // done (true) comes before not done (false)
      //   }
      //   return moment(a.time).diff(moment(b.time)); // earlier time comes first
      // });

      points.sort((a, b) => {
        const pickTime = t => {
          if (t.isDone) {
            return moment(t.time);
          }

          if (['inprogress'].includes(t.status)) {
            return moment(t.time);
          }

          return moment(
            t.isPickup ? t.scheduleTime : t.isDropOff ? t.appointmentTime : null
          );
        };

        const timeA = pickTime(a);
        const timeB = pickTime(b);

        // Step 1: sort by isDone (true first)
        const doneDiff = (b.isDone ? 1 : 0) - (a.isDone ? 1 : 0);
        if (doneDiff !== 0) return doneDiff;

        // Step 2: sort by pickupOrder/dropOffOrder if already exists
        const posA = a.isPickup ? a.pickupOrder : a.isDropOff ? a.dropOffOrder : undefined;
        const posB = b.isPickup ? b.pickupOrder : b.isDropOff ? b.dropOffOrder : undefined;

        if (posA !== undefined && posB !== undefined) {
          return posA - posB;
        }

        // Step 3: sort by time ASCENDING
        return (timeA.isValid() ? timeA : moment(Infinity))
          .diff(timeB.isValid() ? timeB : moment(Infinity));
      });



    }

    console.group('Sorted Points', points);

    return points;
  }

  getPickupEvent(point) {
    const { job } = point;
    const { trackInfoJob = undefined } = job || {};
    let event;
    let isDone = false;
    let isRunning = false;
    if (trackInfoJob) {
      if (trackInfoJob.jobCancelled && trackInfoJob.jobCancelled.eventId !== '0' && trackInfoJob.jobCancelled.time) {
        event = trackInfoJob.jobCancelled;
        isDone = true;
      } else if (trackInfoJob.jobArrived && trackInfoJob.jobArrived.eventId !== '0' && trackInfoJob.jobArrived.time) {
        event = trackInfoJob.jobArrived;
        isDone = true;
      } else if (trackInfoJob.jobAccepted && trackInfoJob.jobAccepted.eventId !== '0' && trackInfoJob.jobAccepted.time) {
        event = trackInfoJob.jobAccepted;
        isRunning = true;
      }
    }

    return { event: (event || null), isDone, isRunning };
  }

  getDropOffEvent(point) {
    const { job } = point;
    const { trackInfoJob = undefined } = job || {};

    let event;
    let isDone = false;
    let isRunning = false;
    if (trackInfoJob) {
      if (trackInfoJob.jobFinished && trackInfoJob.jobFinished.eventId !== '0' && trackInfoJob.jobFinished.time) {
        event = trackInfoJob.jobFinished;
        isDone = true;
      } else if (trackInfoJob.jobCancelled && trackInfoJob.jobCancelled.eventId !== '0' && trackInfoJob.jobCancelled.time) {
        event = trackInfoJob.jobCancelled;
        isDone = true;
      } else if (trackInfoJob.jobCompleted && trackInfoJob.jobCompleted.eventId !== '0' && trackInfoJob.jobCompleted.time) {
        event = trackInfoJob.jobCompleted;
        isDone = true;
      } else if (trackInfoJob.jobStarted && trackInfoJob.jobStarted.eventId !== '0' && trackInfoJob.jobStarted.time) {
        event = trackInfoJob.jobStarted;
        isRunning = true;
      }
    }

    return { event: (event || null), isDone, isRunning };
  }

  getPreviousTrip(pickupPoints) {
    // skip break and return the trip
    let trip;
    for (const point of pickupPoints.slice().reverse()) {
      if (!point.isBreakTrip) {
        trip = point;
        break;
      }
    }
    return trip;
  }

  async getTravelTimeAndDistance(point: any, previousPoint: any, timeZone: any, isGoogleMiles: any) {

    let firstPoint: any = {};
    let secondPoint: any = {};

    // first Pickup Point
    if (previousPoint.isPickup && previousPoint.isDropOff) {
      firstPoint.lat = previousPoint.startingPointAddress.latitude
      firstPoint.lng = previousPoint.startingPointAddress.longitude
    } else if (previousPoint.isPickup) {
      firstPoint.lat = previousPoint.jobOriginLatitude
      firstPoint.lng = previousPoint.jobOriginLongitude
    } else {
      firstPoint.lat = previousPoint.jobDestinationLatitude
      firstPoint.lng = previousPoint.jobDestinationLongitude
    }

    // second Pickup Point
    if (point.isPickup && point.isDropOff) {
      secondPoint.lat = point.startingPointAddress.latitude
      secondPoint.lng = point.startingPointAddress.longitude
    } else if (point.isPickup) {
      secondPoint.lat = point.jobOriginLatitude
      secondPoint.lng = point.jobOriginLongitude
    } else {
      secondPoint.lat = point.jobDestinationLatitude
      secondPoint.lng = point.jobDestinationLongitude
    }

    const distance = await this.assignTripService.getDistance(
      firstPoint.lat,
      firstPoint.lng,
      secondPoint.lat,
      secondPoint.lng,
      isGoogleMiles
    );
    return distance;
  }

  timeValidation(params) {
    const {
      trip,
      violations,
      timeZone
    } = params;
    let isEarly = '';

    // Pickup validation
    if (!(trip.isPickup && trip.isDropOff) && !trip.isDone) {
      if (trip.isPickup) {
        const isLate = moment(trip.eta).tz(timeZone).isAfter(moment(trip.scheduleTime).tz(timeZone));
        let duration = moment.duration(moment(trip.eta).diff(moment(trip.scheduleTime)));

        // Check if violations are available
        if (violations && violations.single) {
          const pickupLateThreshold = violations.single.pickupLate;
          const pickupEarlyThreshold = violations.single.pickupEarly;

          if (pickupLateThreshold !== 0 && isLate && duration.asMinutes() > pickupLateThreshold) {
            isEarly = 'late';
          } else if (pickupEarlyThreshold !== 0 && !isLate && Math.abs(duration.asMinutes()) > pickupEarlyThreshold) {
            isEarly = 'early';
          } else {
            isEarly = 'on time'; // Assuming on time if not late and duration is zero
          }
        } else {
          if (isLate) {
            isEarly = 'late';
          } else if (duration.asMinutes() > 0) {
            isEarly = 'early';
          } else {
            isEarly = 'on time'; // Assuming on time if not late and duration is zero
          }
        }

        // Drop-off validation
      } else {
        const isLate = moment(trip.eta).tz(timeZone).isAfter(moment(trip.appointmentTime).tz(timeZone));
        let duration = moment.duration(moment(trip.eta).diff(moment(trip.appointmentTime)));

        // Check if violations are available
        if (violations && violations.single) {
          const dropoffLateThreshold = violations.single.dropoffLate;
          const dropoffEarlyThreshold = violations.single.dropoffEarly;

          if (dropoffLateThreshold !== 0 && isLate && duration.asMinutes() > dropoffLateThreshold) {
            isEarly = 'late';
          } else if (dropoffEarlyThreshold !== 0 && !isLate && Math.abs(duration.asMinutes()) > dropoffEarlyThreshold) {
            isEarly = 'early';
          } else {
            isEarly = 'on time'; // Assuming on time if not late and duration is zero
          }
        } else {

          if (isLate) {
            isEarly = 'late';
          } else if (duration.asMinutes() > 0) {
            isEarly = 'early';
          } else {
            isEarly = 'on time'; // Assuming on time if not late and duration is zero
          }
        }
      }
    }

    return isEarly;
  }
}
